<template>
  <div style="margin:20px; overflow-x: auto;">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Booking Monthly View</span><br/>
      <span style="font-style: italic; font-size: 18px">Monthly view of TBN bookings by trip date. Bookings in blocks by day for trip sheets and printing.</span>
    </div>

    <div style="position: relative; font-size: 20px; font-weight: bold;" class="align-right d-flex align-items-center justify-content-center">
      <a href="#" class="white-link" v-on:click.prevent="shift_month(-1)"><</a>
      &nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"/>
      &nbsp;to&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_toDate" :config="options" :placeholder="details_toDate"/>
      &nbsp;<a href="#" class="white-link" v-on:click.prevent="shift_month(1)">></a>
      &nbsp;&nbsp;|&nbsp;&nbsp;Filter&nbsp;<b-form-input style="width: 200px" v-model="booking_filter"/>
      &nbsp;&nbsp;|&nbsp;&nbsp;<b-button v-on:click.prevent="load_data()">Search</b-button>
      &nbsp;&nbsp;|&nbsp;&nbsp;<span @click="printPage" style="cursor:pointer" title="Print"><img height="30px" src="/print-icon.png" alt="Print"/></span>
    </div>
    <br/>
    <div v-if="!loading" style="overflow-x: auto; width: 100%;">
      <div v-if="gridVisible" :key="gridKey" style="overflow-x: auto; width: 100%;">
        <!-- Day columns only; rows packed so each day starts at row 1 (no empty gaps) -->
        <table border="1" class="booking-dispatch-table">
          <tr class="table-header-row">
            <th class="th-day-col" v-for="(dc, dIdx) in summary.date_cols" :key="'h-' + dIdx">
              {{ dc.date_month }}/{{ dc.date_day }} - {{ dc.date_weekday }}
            </th>
          </tr>
          <tr v-for="(rowSegments, rowIdx) in packedGrid" :key="'row-' + rowIdx" class="booking-row">
            <template v-for="(seg, segIdx) in rowSegments">
              <td
                v-if="seg.empty"
                :key="'s-' + rowIdx + '-' + segIdx"
                :colspan="seg.colspan"
                class="td-day-cell td-day-empty"
              ></td>
              <td
                v-else
                :key="'s-' + rowIdx + '-' + segIdx"
                :colspan="seg.colspan"
                :class="['td-day-cell', seg.multiday ? 'multiday-cell' : '']"
                @click="toggle_div(seg.booking, 'isVisible')"
              >
                <span>{{ bookingLabel(seg.booking) }}</span>
                <div v-if="seg.booking.isVisible" class="booking-detail-toggle">
                  <b>Booking ID:</b> {{ seg.booking.booking_id }}<br/>
                  <b>Group:</b> {{ seg.booking.group_name || '—' }}<br/>
                  <b>Org:</b> {{ seg.booking.org_name || '—' }}<br/>
                  <b>Trip Ref:</b> {{ seg.booking.trip_reference || '—' }}<br/>
                  <b>Route:</b> {{ seg.booking.route_name || '—' }}<br/>
                  <b>Start:</b> {{ seg.booking.start_location || '—' }}<br/>
                  <b>Finish:</b> {{ seg.booking.finish_location || '—' }}<br/>
                  <b>Pickup:</b> {{ seg.booking.pickup_location || '—' }}<br/>
                  <b>Dropoff:</b> {{ seg.booking.dropoff_location || '—' }}<br/>
                  <b>Contact:</b> {{ seg.booking.contact_name || '—' }}
                </div>
              </td>
            </template>
          </tr>
        </table>
      </div>
    </div>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>
  </div>
</template>
<script>
import { get_tbn_booking_monthly_calendar, api_url } from '../networking/tbn_apis'
import { mapState } from 'vuex'
import { justDate } from '../helpers/dates'
import moment from 'moment'
import axios from 'axios'

export default {
  name: 'booking_monthly_view_tbn',

  data() {
    const start = moment().startOf('month')
    const end = moment().endOf('month')
    return {
      summary: { date_cols: [] },
      loading: true,
      current_date: moment().format('MMMM Do YYYY, h:mm:ss a'),
      details_fromDate: justDate(start),
      details_toDate: justDate(end),
      booking_filter: '',
      booking_filter_debounced: '',
      gridKey: 0,
      gridVisible: true, // toggled to unmount/remount grid when filter changes
      items_full: [],
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(1, 'year'),
        maxDate: moment().add(1, 'year'),
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
    }
  },

  async created() {
    this.load_data()
  },

  methods: {
    bookingLabel(row) {
      // Format: Group Name | Organization | Trip Reference | Booking ID
      const parts = []
      if (row.group_name) parts.push(String(row.group_name).trim())
      if (row.org_name) parts.push(String(row.org_name).trim())
      if (row.trip_reference) parts.push(String(row.trip_reference).trim())
      if (row.booking_id) parts.push('Booking ID: ' + row.booking_id)
      return parts.length ? parts.join(' | ') : 'Booking'
    },
    async printPage() {
      this.$emit('showAlert', 'preparing download...', 'info', 3000)
      const from = moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD')
      const to = moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD')
      const tenant_name = this.user.tenant && this.user.tenant.indexOf('-') !== -1
        ? this.user.tenant.split('-')[0]
        : (this.user.tenant || 'booking')
      const filename = `booking-monthly-${tenant_name}-${from}-to-${to}.html`
      try {
        const response = await axios.post(
          `${api_url}tbn/booking/monthly-calendar/print`,
          {
            tenant: this.user.tenant,
            fromDate: from,
            toDate: to,
            booking_filter: this.booking_filter_debounced || '',
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('jwt')}`,
              Accept: 'text/html',
            },
            responseType: 'text',
          }
        )
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/html' }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(url)
        link.remove()
        this.$emit('showAlert', 'download complete', 'success', 5000)
      } catch (e) {
        this.$emit('showAlert', 'Download failed.', 'danger')
      }
    },
    toggle_div(item, field) {
      item[field] = !item[field]
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2) !== -1
      }
      return false
    },
    isMultiday(booking) {
      if (!booking || !booking.date_records || !Array.isArray(booking.date_records)) return false
      const daysActive = booking.date_records.filter(dr => dr && dr.on_date).length
      return daysActive > 1
    },
    bookingDayRange(booking) {
      // { startDayIndex, endDayIndex } (inclusive) in 0..date_cols.length-1, or null
      const recs = booking.date_records || []
      const cols = this.summary.date_cols || []
      const onDate = (r) => r && (r.on_date === 1 || r.on_date === true || !!r.on_date)
      let start = -1
      let end = -1
      for (let i = 0; i < cols.length && i < recs.length; i++) {
        if (onDate(recs[i])) {
          if (start < 0) start = i
          end = i
        }
      }
      if (start < 0) return null
      return { startDayIndex: start, endDayIndex: end }
    },
    async load_data() {
      this.loading = true
      try {
        const from = moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD')
        const to = moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD')
        const { value: { data } } = await get_tbn_booking_monthly_calendar(this.user.tenant, from, to)
        this.summary = (data && data.summary) ? data.summary : { date_cols: [] }
        // Initialize isVisible on each booking object
        this.items_full = (data && data.results) ? data.results.map(booking => ({
          ...booking,
          isVisible: false
        })) : []
      } catch (e) {
        this.$emit('showAlert', 'Error retrieving booking monthly data. Try logging in again or contact support.', 'danger', 5000)
      }
      this.loading = false
    },
    shift_month(months) {
      const m = moment(this.details_fromDate, 'MM-DD-YYYY').add(months, 'months')
      this.details_fromDate = m.clone().startOf('month').format('MM-DD-YYYY')
      this.details_toDate = m.clone().endOf('month').format('MM-DD-YYYY')
      this.load_data()
    },
  },

  computed: {
    ...mapState({
      user: state => state.profile.user
    }),
    filteredItems() {
      if (!this.booking_filter_debounced) {
        return this.items_full
      }
      const filterLower = this.booking_filter_debounced.toLowerCase()
      return this.items_full.filter(item => 
        this.contains(item.booking_id, filterLower) ||
        this.contains(item.route_name, filterLower) ||
        this.contains(item.group_name, filterLower) ||
        this.contains(item.org_name, filterLower) ||
        this.contains(item.trip_reference, filterLower) ||
        this.contains(item.contact_name, filterLower) ||
        this.contains(item.start_location, filterLower) ||
        this.contains(item.finish_location, filterLower) ||
        this.contains(item.pickup_location, filterLower) ||
        this.contains(item.dropoff_location, filterLower)
      )
    },
    packedGrid() {
      const cols = this.summary.date_cols || []
      const n = cols.length
      if (!n) return []
      const withRange = this.filteredItems
        .map(booking => ({ booking, range: this.bookingDayRange(booking) }))
        .filter(x => x.range != null)
      // Multi-day first (by span length desc), then single-day
      withRange.sort((a, b) => {
        const spanA = a.range.endDayIndex - a.range.startDayIndex + 1
        const spanB = b.range.endDayIndex - b.range.startDayIndex + 1
        if (spanB !== spanA) return spanB - spanA
        return a.range.startDayIndex - b.range.startDayIndex
      })
      const grid = []
      for (const { booking, range } of withRange) {
        const startDay = range.startDayIndex
        const endDay = range.endDayIndex
        const multiday = endDay > startDay
        let r = 0
        while (r < grid.length) {
          let free = true
          for (let d = startDay; d <= endDay; d++) {
            if (grid[r][d] != null) { free = false; break }
          }
          if (free) break
          r++
        }
        if (r === grid.length) {
          grid.push(Array(n).fill(null))
        }
        const cell = { booking, startDay, endDay, multiday }
        for (let d = startDay; d <= endDay; d++) grid[r][d] = cell
      }
      // Convert each row to segments: { colspan, empty } or { colspan, empty: false, booking, multiday }
      return grid.map(row => {
        const segments = []
        let d = 0
        while (d < n) {
          const cell = row[d]
          if (cell == null) {
            let colspan = 0
            while (d + colspan < n && row[d + colspan] == null) colspan++
            segments.push({ colspan, empty: true })
            d += colspan
          } else {
            segments.push({
              colspan: cell.endDay - cell.startDay + 1,
              empty: false,
              booking: cell.booking,
              multiday: cell.multiday
            })
            d = cell.endDay + 1
          }
        }
        return segments
      })
    },
  },

  watch: {
    user: {
      deep: true,
      handler() {
        this.load_data()
      }
    },
    booking_filter: {
      handler(newVal) {
        // Debounce the filter input to avoid freezing
        if (this._filterTimeout) {
          clearTimeout(this._filterTimeout)
        }
        this._filterTimeout = setTimeout(() => {
          this._filterTimeout = null
          if (this._isDestroyed) return
          const newFilter = newVal
          // Unmount grid first so Vue never patches shrinking list (avoids sameVnode(undefined))
          this.gridVisible = false
          this.$nextTick(() => {
            if (this._isDestroyed) return
            this.booking_filter_debounced = newFilter
            this.gridKey = Date.now()
            this.gridVisible = true
          })
        }, 300) // 300ms delay (non-reactive _filterTimeout avoids triggering Vue update in tests)
      },
      immediate: true
    },
  },
  beforeDestroy() {
    if (this._filterTimeout) {
      clearTimeout(this._filterTimeout)
      this._filterTimeout = null
    }
  },
}
</script>

<style scoped>
.white-link { font-size: 22px; font-weight: bold; color: white !important; }

.booking-dispatch-table {
  border-collapse: collapse;
  font-size: 16px;
  min-width: 100%;
}
.booking-dispatch-table th,
.booking-dispatch-table td {
  border: 1px solid #999;
  padding: 8px;
  text-align: left;
  vertical-align: top;
}
.table-header-row th {
  position: sticky;
  top: 0;
  background-color: #F9F8F8;
  font-weight: bold;
  min-width: 180px;
}
.th-booking-col {
  min-width: 235px;
  max-width: 235px;
}
.th-day-col {
  min-width: 180px;
}
.td-booking-label {
  font-weight: bold;
}
.td-booking-label {
  background: #fff;
}
.td-booking-label.multiday-row {
  background-color: #E2E2E2;
}
.booking-row:hover .td-booking-label {
  background: #f5f5f5;
}
.booking-row:hover .td-booking-label.multiday-row {
  background: #d5d5d5;
}
.td-day-cell {
  min-width: 180px;
  min-height: 48px;
}
.td-day-cell.multiday-cell {
  background-color: #E2E2E2;
}
.booking-row {
  cursor: pointer;
}
.booking-detail-toggle {
  margin-top: 6px;
  font-size: 11px;
  line-height: 1.3;
}
</style>
